var r=function(){return!1};export{r as default};
//# sourceMappingURL=stubFalse.js.map
